<a *ngIf="downloadType === 'PDF'" (click)="downloadScreen()" class="dropdown-item">{{downloadType}} Snapshot</a>
<a *ngIf="downloadType === 'PPT'" (click)="downloadScreen()" class="dropdown-item">{{downloadType}} Charts</a>
<a *ngIf="downloadType === 'Excel'" (click)="downloadScreen()" class="dropdown-item">{{downloadType}} Sheet</a>
